import { createContext } from "react";

const AccordionType = ["single", "multiple"] as const;
export type AccordionType = (typeof AccordionType)[number];

export interface AccordionContextResponse {
  values: string[];
  handleToggle?: (value: string) => void;
}
export const AccordionContext = createContext<AccordionContextResponse>({
  values: [],
});
